import { useState } from 'react';

import { Trans } from 'react-i18next';

import {
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    Button,
} from '@mui/material';

import DurationPicker from './DurationPicker';

function DurationPickerDialog({ id, value, open, onClose, handleSubmit, type }) {
    const [duration, setDuration] = useState({ id: id, value: value });

    const handleChange = (update) => {
        setDuration(update);
    };

    const handleSave = () => {
        handleSubmit(duration);
        onClose();
    };

    return (
        <>
            <>
                <Dialog open={open} onClose={onClose}>
                    <DialogTitle><Trans i18nKey='arbeitszeitAuswählen' ns='common'>Arbeitszeit auswählen</Trans></DialogTitle>
                    <DialogContent>
                        <DurationPicker id={id} value={value} onChange={handleChange} type={type} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}><Trans i18nKey='beenden' ns='common'>Beenden</Trans></Button>
                        <Button onClick={handleSave} variant='contained'><Trans i18nKey='speichern' ns='common'>Speichern</Trans></Button>
                    </DialogActions>
                </Dialog>
            </>
        </>
    );
};

export default DurationPickerDialog
